import debounce from "lodash/debounce";
import Flickity from "flickity";

export class Cover {
	private mainTitle: HTMLElement | null = null;
	private cover: HTMLElement | null = null;
	private titleFg: HTMLElement | null = null;
	private titleOffsetLimit = 0;

	constructor() {
		this.mainTitle = document.querySelector<HTMLElement>(".main-title");
		this.cover = document.querySelector<HTMLElement>(".cover");

		if (this.cover != null) {
			if (this.mainTitle != null && !this.cover.classList.contains("no-parallax")) {
				this.titleFg = this.mainTitle.cloneNode(true) as HTMLElement;
				this.titleFg.classList.add("main-title-fg");
				this.cover.appendChild(this.titleFg);

				this.freezeTitleFg();
				window.addEventListener("resize", debounce(() => this.freezeTitleFg(), 200));
			}

			if (!this.cover.classList.contains("no-parallax")) {
				this.setTitleOffsetLimit();

				window.addEventListener("resize", debounce(() => {
					this.setTitleOffsetLimit();
					this.setCoverTransform();
				}, 200));

				window.addEventListener("scroll", () => {
					this.setCoverTransform();
				});
			}
		}

		const arrow = document.querySelector<HTMLElement>(".cover-arrow");
		if (arrow != null) {
			arrow.addEventListener("click", () => {
				if (this.mainTitle != null) {
					document.querySelector(".main-title")?.scrollIntoView({ behavior: "smooth", block: "center" });
				}
			});

			if (this.cover != null) {
				const observer = new IntersectionObserver(function (entries) {
					entries.forEach(function (entry) {
						if (entry.isIntersecting) {
							arrow?.classList.add("is-visible");
						} else {
							arrow?.classList.remove("is-visible");
						}
					});
				}, { threshold: 0.95 });
				observer.observe(this.cover);
			}
		}

		const coverSlider = document.querySelector(".cover-slider");
		if (coverSlider != null) {
			new Flickity(coverSlider, {
				fade: true,
				wrapAround: true,
				setGallerySize: false,
				pageDots: false,
				pauseAutoPlayOnHover: true,
				autoPlay: 5000,
				arrowShape: "M11.27 54.95 70.57 97l4.68-6.59L18.26 50 75.24 9.6 70.56 3 11.27 45.05z"
			});
		}
	}

	freezeTitleFg() {
		if (this.titleFg == null || this.mainTitle == null) {
			return;
		}

		this.titleFg.style.top = this.mainTitle.offsetTop + "px";
		this.titleFg.style.left = this.mainTitle.offsetLeft + "px";
		this.titleFg.style.width = this.mainTitle.offsetWidth + "px";
		this.titleFg.style.textAlign = getComputedStyle(this.mainTitle).textAlign;
	}

	setTitleOffsetLimit() {
		this.titleOffsetLimit = window.innerHeight * 0.35;
	}

	setCoverTransform() {
		if (this.cover == null || this.mainTitle == null || this.titleFg == null) {
			return;
		}

		const scrollTop = window.scrollY || 0;
		const offset = Math.min(scrollTop * 2, this.titleOffsetLimit);

		this.cover.style.transform = `translate3d(0, ${-offset}px, 0)`;
		this.titleFg.style.transform = `translate3d(0, ${offset}px, 0)`;
	}
}
